import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Icon from 'flarum/common/components/Icon';
import { confirmDanger } from './confirmDanger';
const text = k => app.translator.trans(`tarotportal-theme.forum.draft.${k}`, {}, true);
const isDiscussion = state => state.bodyMatches('flarum/forum/components/DiscussionComposer');
const titleOf = state => String(state.fields.title?.() || '').trim();
const hasText = state => !!(titleOf(state) || String(state.fields.content?.() || '').trim());

/**
 * Deleting a draft: closes the composer for good (core's hide(): fields cleared). With a title or
 * text typed, our window asks first — «Удалить черновик?» [Оставить черновик] [Удалить] —
 * instead of the browser's confirm(); an empty composer just closes.
 */
export function discardDraft(state) {
  if (state === void 0) {
    state = app.composer;
  }
  if (!hasText(state)) return state.hide();
  confirmDanger({
    title: text('discard_title'),
    text: text('discard_text'),
    confirmLabel: text('discard_confirm'),
    cancelLabel: text('discard_keep'),
    onconfirm: () => state.hide()
  });
}

/**
 * A minimised composer on phones: core's own minimise / restore (app.composer keeps the section,
 * title, text and uploads), shown as a compact draft panel at the bottom instead of a bar with a
 * lone ×:
 *   ЧЕРНОВИК НОВОЙ ТЕМЫ / Продолжить заполнение →      ×
 *   ЧЕРНОВИК / «Название темы» / Продолжить →          ×
 * The panel restores the same composer (state.show()); × deletes the draft (discardDraft).
 */
export default function addComposerDraft() {
  override('flarum/forum/components/Composer', 'view', function (original) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const vnode = original(...args);
    const state = this.state;
    if (!vnode || !Array.isArray(vnode.children) || state.position !== 'minimized' || app.screen() !== 'phone') return vnode;
    const discussion = isDiscussion(state);
    const title = discussion ? titleOf(state) : '';
    const eyebrow = discussion ? text(title ? 'eyebrow' : 'eyebrow_discussion') : app.translator.trans(`tarotportal-theme.forum.composer.${state.body.attrs?.post ? 'edit' : 'reply'}_kind`, {}, true);
    vnode.attrs.className += ' TpDraft';
    vnode.children.push(m("div", {
      className: "TpDraftBar"
    }, m("button", {
      type: "button",
      className: "TpDraftBar-open",
      onclick: () => state.show()
    }, m("span", {
      className: "TpDraftBar-eyebrow"
    }, eyebrow), title && m("span", {
      className: "TpDraftBar-title"
    }, "\xAB", title, "\xBB"), m("span", {
      className: "TpDraftBar-continue"
    }, text(title || !discussion ? 'continue' : 'continue_filling'), " ", m("span", {
      "aria-hidden": "true"
    }, "\u2192"))), m("button", {
      type: "button",
      className: "TpDraftBar-discard",
      "aria-label": text('discard_label'),
      title: text('discard_label'),
      onclick: () => discardDraft(state)
    }, m(Icon, {
      name: "fas fa-times"
    }))));
    return vnode;
  });

  // The "Новая тема" window on wider screens: its × (core's close) deletes the draft the same way
  extend('flarum/forum/components/Composer', 'controlItems', function (items) {
    if (!items.has('close') || !isDiscussion(this.state)) return;
    const close = items.get('close');
    if (close?.attrs) close.attrs.onclick = () => discardDraft(this.state);
  });
}